/**
 * Copyright schukai GmbH and contributors 2023. All Rights Reserved.
 * Node module: @schukai/monster
 * This file is licensed under the AGPLv3 License.
 * License text available at https://www.gnu.org/licenses/agpl-3.0.en.html
 */

import { extend } from "../../../data/extend.mjs";
import { Link } from "../link.mjs";
import { instanceSymbol } from "../../../constants.mjs";
export { Stylesheet };

/**
 * This class is used by the resource manager to embed external resources.
 *
 * @license AGPLv3
 * @since 1.25.0
 * @copyright schukai GmbH
 * @memberOf Monster.DOM.Resource
 * @summary A Resource class
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link
 */
class Stylesheet extends Link {
	/**
	 * @property {string} rel {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-rel}
	 */
	get defaults() {
		return extend({}, super.defaults, {
			rel: "stylesheet",
		});
	}

	/**
	 * This method is called by the `instanceof` operator.
	 * @returns {symbol}
	 * @since 2.1.0
	 */
	static get [instanceSymbol]() {
		return Symbol.for("@schukai/monster/dom/resource/link/stylesheet");
	}
}
